import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import { HeartIcon, HomeIcon, ShieldIcon, BusIcon, BuildingIcon, MonitorIcon, BedIcon, ShowerHeadIcon, TrophyIcon, HardHatIcon, GraduationCapIcon, MicIcon, StethoscopeIcon, LampIcon, LockIcon, HandIcon, ArrowRightIcon } from 'lucide-react';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
const Support = () => {
  const priorityProjects = [{
    title: 'Perimeter Fencing',
    description: 'Erection of perimeter fencing to enhance security and define school boundaries.',
    icon: <ShieldIcon className="h-6 w-6 text-blue-700" data-id="element-5727" />,
    category: 'Security',
    progress: 25
  }, {
    title: 'Street Lighting',
    description: 'Installation of strategically positioned street lighting throughout the premises for improved security and visibility.',
    icon: <LampIcon className="h-6 w-6 text-blue-700" data-id="element-5728" />,
    category: 'Security',
    progress: 15
  }, {
    title: 'Security Personnel',
    description: 'Employment of both Day and Night Security Personnel to ensure 24/7 protection of the school premises.',
    icon: <LockIcon className="h-6 w-6 text-blue-700" data-id="element-5729" />,
    category: 'Security',
    progress: 10
  }, {
    title: 'School Bus',
    description: 'Provision of a School Bus to facilitate transportation for students and staff for educational trips and events.',
    icon: <BusIcon className="h-6 w-6 text-blue-700" data-id="element-5730" />,
    category: 'Transportation',
    progress: 30
  }, {
    title: 'Administrative Block',
    description: 'Reinforcement and refurbishment of the Administrative Block to create a more functional and professional environment.',
    icon: <BuildingIcon className="h-6 w-6 text-blue-700" data-id="element-5731" />,
    category: 'Infrastructure',
    progress: 40
  }, {
    title: 'ICT Laboratory',
    description: 'Renovation of a section of the Dining Hall to function as the new ICT Laboratory with modern computing facilities.',
    icon: <MonitorIcon className="h-6 w-6 text-blue-700" data-id="element-5732" />,
    category: 'Academic Facilities',
    progress: 20
  }, {
    title: 'School Hostel',
    description: 'Revitalization of the School Hostel through the refurbishment of select buildings and extensive promotional efforts.',
    icon: <BedIcon className="h-6 w-6 text-blue-700" data-id="element-5733" />,
    category: 'Student Accommodation',
    progress: 35
  }, {
    title: 'Toilet Facilities',
    description: 'Expansion of toilet facilities for both staff and students to improve sanitation and comfort.',
    icon: <ShowerHeadIcon className="h-6 w-6 text-blue-700" data-id="element-5734" />,
    category: 'Infrastructure',
    progress: 15
  }, {
    title: 'Athletic Facilities',
    description: "Enhancement of the school's athletic facilities to promote physical education and sports excellence.",
    icon: <TrophyIcon className="h-6 w-6 text-blue-700" data-id="element-5735" />,
    category: 'Sports',
    progress: 25
  }, {
    title: 'Roof and Ceiling Repairs',
    description: 'Repair of select roofs and ceilings to ensure safe and comfortable learning environments.',
    icon: <HardHatIcon className="h-6 w-6 text-blue-700" data-id="element-5736" />,
    category: 'Infrastructure',
    progress: 45
  }, {
    title: 'Scholarship Programs',
    description: 'Introduction of additional scholarship programs for deserving students to ensure access to quality education.',
    icon: <GraduationCapIcon className="h-6 w-6 text-blue-700" data-id="element-5737" />,
    category: 'Academic Support',
    progress: 30
  }, {
    title: 'School Hall',
    description: 'Modernization of the School Hall to better accommodate assemblies, events, and performances.',
    icon: <MicIcon className="h-6 w-6 text-blue-700" data-id="element-5738" />,
    category: 'Infrastructure',
    progress: 20
  }, {
    title: 'School Clinic',
    description: 'Recruitment of healthcare professionals for the School Clinic to ensure proper medical care for students and staff.',
    icon: <StethoscopeIcon className="h-6 w-6 text-blue-700" data-id="element-5739" />,
    category: 'Health Services',
    progress: 15
  }];
  const supportCategories = [{
    title: 'Financial Donations',
    description: "Make a direct financial contribution to support our school's development projects and programs.",
    icon: <HandIcon className="h-10 w-10 text-white" data-id="element-5740" />,
    color: 'bg-blue-700',
    link: '/support/donate'
  }, {
    title: 'Material Donations',
    description: 'Donate books, computers, laboratory equipment, sports gear, and other educational materials.',
    icon: <HomeIcon className="h-10 w-10 text-white" data-id="element-5741" />,
    color: 'bg-yellow-500',
    link: '/support/material-donations'
  }, {
    title: 'Volunteer',
    description: 'Share your expertise, time, and skills to support our educational programs and extracurricular activities.',
    icon: <HeartIcon className="h-10 w-10 text-white" data-id="element-5742" />,
    color: 'bg-green-600',
    link: '/support/volunteer'
  }, {
    title: 'Corporate Partnerships',
    description: 'Explore partnership opportunities for corporate social responsibility initiatives and sponsorships.',
    icon: <BuildingIcon className="h-10 w-10 text-white" data-id="element-5743" />,
    color: 'bg-purple-600',
    link: '/support/corporate-partnerships'
  }];
  return <div className="min-h-screen bg-white" data-id="element-5744">
      <PageHeader title="Support Isonyin Grammar School" description="Join our community of supporters and help shape the future of education at Isonyin Grammar School." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Support',
      path: '/support'
    }]} data-id="element-5745" />
      <div className="container mx-auto px-4 py-12" data-id="element-5746">
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-5747">
          <div className="text-center mb-10" data-id="element-5748">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5749">
              Supporting Excellence in Education
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5750"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5751">
              Your support helps us maintain our tradition of excellence and
              expand opportunities for our students.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-5752">
            <div data-id="element-5753">
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-5754">
                For over five decades, Isonyin Grammar School has been committed
                to providing quality education that prepares students for future
                success. This commitment requires resources, dedication, and the
                support of our community.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-5755">
                There are many ways you can contribute to the growth and
                development of our school. Whether through financial donations,
                volunteering your time and expertise, or participating in our
                fundraising initiatives, your support makes a significant
                difference in the lives of our students.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-5756">
                By supporting Isonyin Grammar School, you are investing in the
                future of our students and our community. Join us in our mission
                to provide an exceptional educational experience that develops
                well-rounded individuals who excel academically and contribute
                positively to society.
              </p>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg border border-blue-100 shadow-md" data-id="element-5757">
              <h3 className="text-xl font-bold text-blue-900 mb-4 text-center" data-id="element-5758">
                Ways to Support
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-5759">
                {supportCategories.map((category, index) => <div key={index} className="text-center" data-id="element-5760">
                    <div className={`${category.color} p-4 rounded-full inline-flex items-center justify-center mb-3`} data-id="element-5761">
                      {category.icon}
                    </div>
                    <h4 className="font-bold text-blue-900 mb-2" data-id="element-5762">
                      {category.title}
                    </h4>
                    <p className="text-sm text-gray-700 mb-3" data-id="element-5763">
                      {category.description}
                    </p>
                    <Button href={category.link} variant="text" size="sm" className="text-blue-700" data-id="element-5764">
                      Learn More
                    </Button>
                  </div>)}
              </div>
            </div>
          </div>
        </section>
        {/* Recent Commissionings Section */}
        <section className="mb-16" data-id="element-5765">
          <div className="text-center mb-10" data-id="element-5766">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5767">
              Recent Project Commissionings
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5768"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5769">
              We're proud to showcase our recently completed and commissioned
              projects that are already making a positive impact on our
              students' educational experience.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5770">
            <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-5771">
              <div className="relative h-64 overflow-hidden" data-id="element-5772">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tj13uTG1CCX8nkvziVAAab/WhatsApp_Image_2025-10-24_at_10.01.17_%281%29.jpg" alt="ICT Laboratory" className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" data-id="element-5773" />
                <div className="absolute top-4 left-4 bg-yellow-500 text-blue-900 text-xs font-bold py-1 px-2 rounded" data-id="element-5774">
                  RECENTLY COMMISSIONED
                </div>
              </div>
              <div className="p-6" data-id="element-5775">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5776">
                  New ICT Laboratory
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-5777">
                  Our state-of-the-art ICT Laboratory was recently commissioned,
                  featuring 25 modern computer workstations, high-speed
                  internet, and educational software to enhance digital literacy
                  among our students. Donated by Old Students Association 75/80
                  Set.
                </p>
                <div className="flex items-center justify-between" data-id="element-5778">
                  <span className="text-sm text-gray-500" data-id="element-5779">
                    Commissioned: 2024
                  </span>
                  <Button href="/project-commissioning" variant="outline" size="sm" data-id="element-5780">
                    View Details
                  </Button>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-5781">
              <div className="relative h-64 overflow-hidden" data-id="element-5782">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jA5f2egHsPW6YcMhP4RtXv/WhatsApp_Image_2025-10-24_at_10.01.18_%281%29.jpg" alt="Chemistry Laboratory Renovation" className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" data-id="element-5783" />
                <div className="absolute top-4 left-4 bg-yellow-500 text-blue-900 text-xs font-bold py-1 px-2 rounded" data-id="element-5784">
                  RECENTLY COMMISSIONED
                </div>
              </div>
              <div className="p-6" data-id="element-5785">
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5786">
                  Chemistry Laboratory Renovation
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-5787">
                  Our chemistry laboratory has been completely renovated with
                  new laboratory benches, modern equipment, improved
                  ventilation, and safety features. Generously donated by Old
                  Students Association 75/80 Set.
                </p>
                <div className="flex items-center justify-between" data-id="element-5788">
                  <span className="text-sm text-gray-500" data-id="element-5789">
                    Commissioned: January 27, 2024
                  </span>
                  <Button href="/project-commissioning" variant="outline" size="sm" data-id="element-5790">
                    View Details
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-8" data-id="element-5791">
            <Button href="/project-commissioning" variant="secondary" icon={<ArrowRightIcon data-id="element-5793" />} iconPosition="right" data-id="element-5792">
              View All Commissioned Projects
            </Button>
          </div>
        </section>
        {/* Current Needs / Priority Projects Section */}
        <section className="mb-16" id="priority-projects" data-id="element-5794">
          <div className="text-center mb-10" data-id="element-5795">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5796">
              Current Needs & Priority Projects
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5797"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5798">
              These are the specific areas where the school requires financial
              or material support to improve our facilities and enhance the
              educational experience of our students.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-5799">
            {priorityProjects.map((project, index) => <Card key={index} hover className="h-full" data-id="element-5800">
                <div className="flex items-start" data-id="element-5801">
                  <div className="bg-blue-100 p-3 rounded-full mr-4 flex-shrink-0" data-id="element-5802">
                    {project.icon}
                  </div>
                  <div data-id="element-5803">
                    <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full mb-2" data-id="element-5804">
                      {project.category}
                    </span>
                    <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5805">
                      {project.title}
                    </h3>
                    <p className="text-gray-700 mb-4" data-id="element-5806">{project.description}</p>
                    <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-5807">
                      <div className="bg-blue-600 h-2.5 rounded-full" style={{
                    width: `${project.progress}%`
                  }} data-id="element-5808"></div>
                    </div>
                    <div className="flex justify-between mt-2 text-sm" data-id="element-5809">
                      <span className="text-gray-600" data-id="element-5810">Progress</span>
                      <span className="text-blue-700 font-medium" data-id="element-5811">
                        {project.progress}%
                      </span>
                    </div>
                  </div>
                </div>
              </Card>)}
          </div>
        </section>
        {/* Donation Process Section */}
        <section className="mb-16" data-id="element-5812">
          <div className="text-center mb-10" data-id="element-5813">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5814">
              How to Donate
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5815"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5816">
              Making a donation to Isonyin Grammar School is simple and secure.
              Follow these steps to contribute to our development projects.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-5817">
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 text-center" data-id="element-5818">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-5819">
                <span className="text-blue-700 font-bold text-xl" data-id="element-5820">1</span>
              </div>
              <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-5821">
                Choose a Project
              </h3>
              <p className="text-gray-700" data-id="element-5822">
                Select a specific project you'd like to support or make a
                general donation to the school.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 text-center" data-id="element-5823">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-5824">
                <span className="text-blue-700 font-bold text-xl" data-id="element-5825">2</span>
              </div>
              <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-5826">
                Contact Us
              </h3>
              <p className="text-gray-700" data-id="element-5827">
                Reach out to our development office to discuss your donation and
                receive transfer details.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 text-center" data-id="element-5828">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-5829">
                <span className="text-blue-700 font-bold text-xl" data-id="element-5830">3</span>
              </div>
              <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-5831">
                Make Your Donation
              </h3>
              <p className="text-gray-700" data-id="element-5832">
                Complete your donation via bank transfer, check, or in-person at
                our administrative office.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 text-center" data-id="element-5833">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-5834">
                <span className="text-blue-700 font-bold text-xl" data-id="element-5835">4</span>
              </div>
              <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-5836">
                Receive Acknowledgment
              </h3>
              <p className="text-gray-700" data-id="element-5837">
                Get an official receipt and acknowledgment of your generous
                contribution to our school.
              </p>
            </div>
          </div>
          <div className="mt-10 text-center" data-id="element-5838">
            <Button href="/contact" variant="primary" size="lg" icon={<ArrowRightIcon data-id="element-5840" />} iconPosition="right" data-id="element-5839">
              Contact Our Development Office
            </Button>
          </div>
        </section>
        {/* Recognition Section */}
        <section className="mb-16 bg-blue-50 p-8 rounded-lg" data-id="element-5841">
          <div className="text-center mb-10" data-id="element-5842">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5843">
              Donor Recognition
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5844"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5845">
              We appreciate and recognize the generosity of our donors who
              contribute to the development of Isonyin Grammar School.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-5846">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-5847">
              <h3 className="text-xl font-bold text-blue-900 mb-3 text-center" data-id="element-5848">
                Donor Wall
              </h3>
              <p className="text-gray-700 text-center" data-id="element-5849">
                Major donors are recognized on our Donor Wall located in the
                school's main administration building, showcasing their
                significant contributions to our development.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-5850">
              <h3 className="text-xl font-bold text-blue-900 mb-3 text-center" data-id="element-5851">
                Annual Report
              </h3>
              <p className="text-gray-700 text-center" data-id="element-5852">
                All donors are acknowledged in our Annual Report, which
                highlights the school's achievements and the impact of donations
                on our programs and facilities.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-5853">
              <h3 className="text-xl font-bold text-blue-900 mb-3 text-center" data-id="element-5854">
                Naming Opportunities
              </h3>
              <p className="text-gray-700 text-center" data-id="element-5855">
                Significant donations may qualify for naming opportunities,
                allowing donors to name a facility, scholarship, or program in
                honor of themselves or a loved one.
              </p>
            </div>
          </div>
        </section>
        {/* CTA Section */}
        <section className="bg-gradient-to-r from-blue-900 to-blue-800 text-white rounded-lg overflow-hidden" data-id="element-5856">
          <div className="container mx-auto px-4 py-12" data-id="element-5857">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-5858">
              <div data-id="element-5859">
                <h2 className="text-3xl font-bold mb-4" data-id="element-5860">
                  Make a Difference Today
                </h2>
                <p className="mb-6 leading-relaxed" data-id="element-5861">
                  Your support, regardless of size, can make a significant
                  impact on the lives of our students and the future of Isonyin
                  Grammar School. Join us in our mission to provide quality
                  education and develop future leaders.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-5862">
                  <Button href="/contact" variant="primary" size="lg" data-id="element-5863">
                    Contact Us
                  </Button>
                  <Button href="/support/donate" variant="outline" size="lg" className="border-white text-white hover:bg-white/10" data-id="element-5864">
                    Donate Now
                  </Button>
                </div>
              </div>
              <div className="relative" data-id="element-5865">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg" alt="Students at Isonyin Grammar School" className="rounded-lg shadow-lg" data-id="element-5866" />
                <div className="absolute -bottom-4 -right-4 bg-yellow-500 text-blue-900 font-bold py-2 px-4 rounded-lg transform rotate-3 shadow-lg" data-id="element-5867">
                  Thank You for Your Support!
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default Support;